import api from "../Services/fetch";
export const recaptcha = `https://www.google.com/recaptcha/api`;
export const keyRecaptcha = process.env.REACT_APP_SECRET_KEY || "";
export const recaptchaAPI = api(recaptcha);

export const baseUrl = process.env.REACT_APP_BASE_URL || "";
export const apiKey = process.env.REACT_APP_API_KEY || "";

// Contact-us
export const contactusAPIUrl = process.env.REACT_APP_CONTACTUS_URL || "";
export const contactUsApiKey = process.env.REACT_APP_CONTACTUS_API_KEY || "";
export const contactusAPI = api(contactusAPIUrl);

// Contacts
export const contactsAPIUrl = process.env.REACT_APP_CONTACTUS_UR || "";
export const contactsAPI = api(contactsAPIUrl);
